module.exports = __webpack_public_path__ + "static/media/sas.05c4ce63.jpg";